import { Component, OnInit } from '@angular/core';
import { logbaseService } from '../services/logbase.service';
import { environment } from '../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

  approvedPackageUrl: any;
  allPartsDataUrl: any;
  partLevelMasterUrl: any;


  constructor(private logbaseService: logbaseService, 
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();

    this.logbaseService.getUrisForDownload().subscribe(result => {
      this.approvedPackageUrl = result.response.approvedPackageUri;
      this.partLevelMasterUrl=result.response.partLevelMasterUri;
      this.allPartsDataUrl=result.response.allPartsDataUri;
      this.spinner.hide();
    }, (error:any)=>{this.spinner.hide();});
  }

  saas_approved_packages: any=environment.approved_packages_saas;

  downloadApprovedPackageCSV() {
    window.location.assign(this.approvedPackageUrl+"?"+environment.approved_packages_saas);    
  }

  downloadAllPartsDataCSV() {
    window.location.assign(this.allPartsDataUrl+"?"+environment.all_parts_data);    
  }

  downloadPartLevelMasterCSV() {
    window.location.assign(this.partLevelMasterUrl+"?"+environment.part_level_master);    
  }

  

}
